import Card from 'app/frontend/base/components/Card'
import { imageUrl } from 'app/frontend/base/helpers'
import Difficulty from 'app/frontend/types/custom/Difficulty'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export type LinkPlanEncounterOption = {
  activityId: number
  encounterId: number
  difficulty: Difficulty
  name: string
  thumbnailUrl?: string | null
  instanceTileUrl?: string | null
  activityType: string
  linkedPlanCount: number
}

type Props = {
  encounter: LinkPlanEncounterOption
  isActive: boolean
  onClick: () => void
}

const LinkPlanEncounterCard = ({ encounter, isActive, onClick }: Props) => {
  return (
    <div className='relative flex w-9 min-w-0 sm:w-auto sm:flex-1 sm:basis-0'>
      {encounter.linkedPlanCount > 0 ? (
        <Badge
          variant='info'
          className='pointer-events-none border-info-foreground border absolute -right-1.5 -top-1.5 z-10 h-5 min-w-5 justify-center px-1 text-xs tabular-nums'
        >
          {encounter.linkedPlanCount}
        </Badge>
      ) : null}
      <Card
        className={cn(
          'flex w-full min-w-0 cursor-pointer flex-col overflow-hidden p-0 transition-colors sm:flex-row sm:flex-wrap sm:items-center sm:justify-center sm:gap-1 sm:p-1.5',
          isActive
            ? 'border-primary hover:border-primary'
            : 'hover:border-primary/50',
        )}
        onClick={onClick}
      >
        <div className='relative w-full shrink-0 overflow-hidden sm:w-10 sm:rounded-md'>
          <img
            src={
              encounter.thumbnailUrl ??
              encounter.instanceTileUrl ??
              imageUrl(`activity-thumbnails/${encounter.activityType}.jpg`)
            }
            className='h-9 w-full object-cover sm:h-10'
          />
          <div className='absolute bottom-0 right-0 rounded-tl-[8px] bg-card-nested/70 px-0.5 py-0.5 text-[10px] font-semibold leading-none'>
            {encounter.difficulty?.[0].toUpperCase() ?? '-'}
          </div>
        </div>
        <div className='flex min-w-0 flex-col items-center justify-center gap-0.5 p-1 sm:flex-1 sm:basis-12 sm:flex-row sm:gap-1 sm:p-0'>
          <span className='hidden truncate text-xs font-medium sm:block'>
            {encounter.name}
          </span>
        </div>
      </Card>
    </div>
  )
}

export default LinkPlanEncounterCard
